export const CAROUSEL_CURRENT_SLIDE_CHANGED = 'CAROUSEL_CURRENT_SLIDE_CHANGED';
export const CAROUSEL_NEXT_SLIDE = 'CAROUSEL_NEXT_SLIDE';
export const CAROUSEL_PAUSED = 'CAROUSEL_PAUSED';
export const CAROUSEL_UNPAUSED = 'CAROUSEL_UNPAUSED';
export const CAROUSEL_VIDEO_PLAYING = 'CAROUSEL_VIDEO_PLAYING';
export const CAROUSEL_VIDEO_PROGRESS = 'CAROUSEL_VIDEO_PROGRESS';

export const carouselNextSlideCreator = carouselSliceId => ({
  type: CAROUSEL_NEXT_SLIDE,
  payload: {
    carouselSliceId,
  },
});

export const carouselSlideChangedCreator = (carouselSliceId, slideIndex) => ({
  type: CAROUSEL_CURRENT_SLIDE_CHANGED,
  payload: {
    carouselSliceId,
    slideIndex,
  },
});

export const carouselVideoPlayingCreator = (carouselSliceId, duration) => ({
  type: CAROUSEL_VIDEO_PLAYING,
  payload: {
    carouselSliceId,
    duration,
  },
});

export const carouselVideoProgressCreator = (carouselSliceId, currentTime) => ({
  type: CAROUSEL_VIDEO_PROGRESS,
  payload: {
    carouselSliceId,
    currentTime,
  },
});

export const carouselPausedCreator = carouselSliceId => ({
  type: CAROUSEL_PAUSED,
  payload: { carouselSliceId },
});

export const carouselUnpausedCreator = carouselSliceId => ({
  type: CAROUSEL_UNPAUSED,
  payload: { carouselSliceId },
});
